<footer>
  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-md-4 d-flex flex-column align-items-start">
        <img src="../../../assets/images/footer-logo.png" alt="" class="footer-logo">
        <div class="social">
          <div class="text">
            {{ "SOCIAL_TEXT" | translate }}
          </div>
          <div class="icons">
            <a (click)="openLink('https://www.facebook.com/share/15TcFc8yWP/')">
              <img src="../../../assets/images/facebook-fill.png" alt="">
            </a>

            <a (click)="openLink('https://www.instagram.com/hidayaapp/')">
              <img src="../../../assets/images/instagram-fill.png" alt="">
            </a>

            <a (click)="openLink('https://www.youtube.com/@hidaya-app')">
              <img src="../../../assets/images/youtube-fill.png" alt="">
            </a>

            <a (click)="openLink('https://x.com/HidayaInfo?t=g09BDia3cd_tatVcqW2mvA&s=09')">
              <img src="../../../assets/images/twitter-x.png" alt="">
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 d-flex justify-content-md-center">
        <div class="quick-links">
          <span class="title">{{ "QUICK_LINKS" | translate }}</span>
          <ul>
            <li>
              <a routerLink="" fragment="about_hidaya" [routerLinkActiveOptions]="{ exact: true }"
                routerLinkActive="active">{{ "ABOUT_HEDAYA" | translate }}</a>
            </li>

            <li>
              <a routerLink="" fragment="available_packages" [routerLinkActiveOptions]="{ exact: true }"
                routerLinkActive="active">{{ "AVAILABLE_PACKAGES" | translate }}</a>
            </li>

            <li>
              <a routerLink="" fragment="faq" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">{{
                "FAQ" | translate }}</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" routerLink="/privacy-policy" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">{{ "PRIVACY_POLICY" | translate }}</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" routerLink="/terms-conditions" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">{{ "TERMS_CONDITIONS" | translate }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-sm-12 col-md-4">
        <div class="downloads">
          <span class="title">{{ "DOWNLOAD_APP" | translate }}</span>
          <span class="note">{{ "DOWNLOAD_APP_NOTE" | translate }}</span>
          <div class="app-links">
            <a href="https://apps.apple.com/eg/app/hidaya-libya/id6742405750?l=ar" target="_blank">
              <img src="../../../assets/images/app-store.png" alt="">
            </a>

            <a href="https://play.google.com/store/apps/details?id=com.hidayalibya&hl=en" target="_blank">
              <img src="../../../assets/images/google-play.png" alt="">
            </a>
          </div>
        </div>
      </div>
      <div class="col-12 d-flex align-items-center flex-column">
        <span class="copy-rights">{{ "COOPERATION_WITH" | translate }}</span>
      </div>
      <div class="col-12">
        <hr>
      </div>
      <div class="col-12 d-flex align-items-center flex-column">
        <span class="copy-rights">{{ "COPY_RIGHTS" | translate }}</span>
      </div>
    </div>
  </div>
</footer>